<template>
  <a
    v-if="icon === 'email'"
    :href="`mailto:${content.personalData.email}`"
    class="icon-wrapper email-bg"
  >
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
    >
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
    </svg>
  </a>

  <a v-else-if="icon === 'home'" class="icon-wrapper">
    <svg
      viewBox="0 0 477.175 477.175"
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      :fill="content.svgIcon.fill"
    >
      <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225 c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z" />
    </svg>
  </a>

  <a
    v-else-if="icon === 'linkedin'"
    :href="content.personalData.linkedin"
    target="_blank"
    rel="noopener"
    class="icon-wrapper linkedin-bg"
  >
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
    >
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
    </svg>
  </a>
</template>

<script>
import content from "../../public/content.json";

export default {
  name: "EmailLogo",
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      content,
    };
  },
};
</script>

<style lang="scss" scoped>
.icon-wrapper {
  margin-top: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  opacity: 0.87;
  transition: var(--transition);

  background: white;

  &.linkedin-bg {
    background: #0077b5 !important;
    .icon {
      fill: white !important;
    }
    &:hover {
      background: #005582 !important;
    }
  }

  &.email-bg {
    background: #ffffff !important;
    .icon {
      fill: rgb(0, 0, 0) !important;
    }
    &:hover {
      background: #b9b9b9 !important;
    }
  }

  .icon {
    width: 40px;
    height: 40px;
    transition: var(--transition);
    // This ensures the SVG color follows the 'fill' we set above
  }

  &:hover {
    opacity: 1;
    .icon {
      width: 50px;
      height: 50px;
    }
  }
}
</style>

